import React, { useState, useEffect } from 'react';

import CssBaseline from '@material-ui/core/CssBaseline';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import NavMenu from 'components/NavMenu';
import Paper from '@material-ui/core/Paper';
import TextEvents from 'app/components/TextEvents';
import { Table, Drawer, Button, Modal, Spin, Select, Upload, Icon, Radio } from 'antd'
import { useStyles, styles } from './SignatureScreenStyles';
import { useDispatch, useSelector } from 'react-redux';
import ApiService from 'app/services/ApiService';

import * as SignatureActions from '../../actions/SignatureActions'
import FilterScreen from './FilterComponent/FilterComponent';
import { Grid } from '@material-ui/core';
import TextInput from '../../components/TextInput';
import TableScreen from './TableComponent/TableComponent';


export default function SignatureScreen(props) {
    const { siteId } = useSelector(state => state.Auth)
    const { confirm } = Modal;

    const {
        isLoadingSignature,
        isDeleting,
        isSaving,
        listContrat,
        listCategory,
        listSignature,
        pagination
    } = useSelector(state => state.SignatureReducer);

    const optionAllKeyUser = listCategory.map((item) =>
        (<Select.Option key={item.employeeId} value={item.employeeId}>{item.employeeName}</Select.Option>)
    );

    const optionAllContracts = listContrat.map((item) =>
        (<Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)
    );


    //Carga de firma
    const [state_, setState_] = useState({
        fileList: [],
        finishedOrError: false,
        uploading: false,
    })

    const { uploading, fileList } = state_;

    const actions = {
        multiple: false,
        onRemove: file => {
            setState_(state => {
                const index = state_.fileList.indexOf(file);
                const newFileList = state_.fileList.slice();
                newFileList.splice(index, 1);
                return {
                    fileList: newFileList,
                };
            });
        },
        beforeUpload: file => {
            setState_(state => ({
                fileList: [...state_.fileList, file],
            }));
            return false;
        },
        fileList,
    };
    //Finaliza Carga de firma

    const classes = useStyles();
    const dispatch = useDispatch();

    const [filter, setFilter] = useState([]);
    // const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros` });
    const [sorter, setSorter] = useState({});
    const [formData, setFormData] = useState({});
    const [selectedContracts, setSelectedContracts] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [visibleModal, setVisibleModal] = useState(false);
    const [idSignature, setIdSignature] = useState('');
    const [userName, setUserName] = useState('');
    const [signatureType, setSignatureType] = useState();
    const [selectedFilterNames, setSelectedFilterNames] = useState([]);
    const [selectedFilterCategory, setSelectedFilterCategory] = useState([]);

    useEffect(() => {
        dispatch(SignatureActions.cleanSignature());
        dispatch(SignatureActions.getSignaturesContracs());
        dispatch(SignatureActions.getSignaturesECategory());
        dispatch(SignatureActions.getListSignatures({
            Offset: 0,
            Limit: 25
        }))
        dispatch(SignatureActions.getSignaturesFilters());

    }, [dispatch]);

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    const newSignature = () => {
        setVisibleModal(true);
    }

    const submit = () => {
        var payload = {
            employeeId: userName,
            type: signatureType,
            contract: []
        }

        if (idSignature != '') {
            payload.idSignatory = idSignature;
        }
        selectedContracts.forEach(x => {
            payload.contract.push({ idContract: x })
        })

        dispatch(SignatureActions.postSignatory(payload, updateTable));

    }

    const showConfirmDelete = (data) => {
        confirm({
            title: '¿Eliminar Firmante?',
            content: data.employeeName,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                dispatch(SignatureActions.delSignature(data.idSignatory, updateTable))
            },
            onCancel() { },
        });
    }

    const updateTable = (value) => {

        dispatch(SignatureActions.getListSignatures({
            Offset: 0,
            Limit: 25
        }))

        setVisibleModal(false);
        setSelectedContracts([]);
        setSelectedCategory('');
        setUserName('');
        setIdSignature('');
        setSignatureType(null);
        setSelectedFilterNames([]);
        setSelectedFilterCategory([]);
    }

    const bloqueado = () => {
        if (selectedContracts.length != 0
            && selectedCategory != ''
            && userName != ''
            && (signatureType == 1 || signatureType == 2)) return false
        return true
    }

    const CategorySetChanges = (payload, payload2) => {
        setUserName(payload);
        let indx = listCategory.findIndex(x => x.employeeId == payload);
        if (indx != -1) {
            setSelectedCategory(listCategory[indx].categoryName)
        }
    }

    const editSystem = async (record) => {

        setIdSignature(record.idSignatory)
        setSignatureType(record.idType);
        var contracts = record.contractId.split(',');
        setSelectedContracts(contracts);

        let indx = listCategory.findIndex(x => x.employeeName == record.employeeName);
        if (indx != -1) {
            setSelectedCategory(listCategory[indx].categoryName)
            setUserName(listCategory[indx].employeeId);
        }

        setVisibleModal(true);
    }

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isCatalog={true} header='Firmantes' isCommunicationStatus={false} />
            <CssBaseline />
            <div className={classes.content}>
                <Modal
                    destroyOnClose={true}
                    onCancel={() => setVisibleModal(false)}
                    visible={visibleModal}
                    title={<TextEvents
                        text={idSignature === '' ? 'Nuevo Firmante' : ((siteId === "HUB" ? 'Editar' : 'Visualizar') + ' Firmante')}
                        color='cotemar'
                        size='label'
                        weight='bold'
                    />}
                    width={'650px'}
                    centered={true}
                    footer={[
                        <Button key="back" type="danger" ghost onClick={() => updateTable(1)}>
                            Cancelar
                        </Button>,
                        siteId === "HUB" ?
                            <Button disabled={bloqueado()} key="submit" type="primary" loading={false} onClick={() => submit()}>
                                Confirmar
                            </Button> : null,
                    ]}
                >
                    <Spin spinning={isSaving}>
                        <Grid container>
                            <Grid item xs={12}>
                                <TextEvents
                                    text='Nombre:'
                                    color="darker"
                                    size='label'
                                    weight="medium"
                                />
                                <Select
                                    value={userName}
                                    showSearch
                                    onChange={CategorySetChanges}
                                    placeholder='Escriba el nombre del usuario'
                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                    optionFilterProp="Children"
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    mode="single"
                                >
                                    {optionAllKeyUser}
                                </Select>
                            </Grid>
                            <Grid item xs={12}>
                                <TextInput
                                    value={selectedCategory}
                                    setValue={setSelectedCategory}
                                    text='Puesto:'
                                    color='darker'
                                    size='label'
                                    weight='medium'
                                    mode='input'
                                    placeholder='Puesto del usuario'
                                    disabled={true}
                                />
                            </Grid>
                            {/* <Grid item xs={12}>
                                <TextEvents
                                    text='Firma:'
                                    color="darker"
                                    size='label'
                                    weight="medium"
                                />
                                <Upload {...actions} accept={'.png'}>
                                    <Button>
                                        <Icon type="upload" /> Seleccione la firma...
                                    </Button>
                                </Upload>
                            </Grid> */}
                            <Grid item xs={12}>
                                <TextEvents
                                    text='Contrato:'
                                    color="darker"
                                    size='label'
                                    weight="medium"
                                />
                                <Select
                                    value={selectedContracts}
                                    showSearch
                                    onChange={setSelectedContracts}
                                    placeholder='Seleccione un contrato'
                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                    optionFilterProp="Children"
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    mode="multiple"
                                >
                                    {optionAllContracts}
                                </Select>
                            </Grid>
                            <Grid item xs={12}>
                                <TextEvents
                                    text='Tipo Firmante:'
                                    color="darker"
                                    size='label'
                                    weight="medium"
                                />
                                <Radio.Group
                                    onChange={(e) => {
                                        setSignatureType(e.target.value)
                                    }}
                                    value={signatureType}>
                                    <Radio value={1}>Firmante 1</Radio>
                                    <Radio value={2}>Firmante 2</Radio>
                                </Radio.Group>
                            </Grid>
                        </Grid>
                    </Spin>
                </Modal>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label='Breadcrumb'>
                        <Link color='inherit' disabled>
                            Catálogos
                        </Link>
                        <TextEvents
                            text={'Firmantes'}
                            color='cotemar'
                            size='subtitle'
                            weight='bold'
                        />
                    </Breadcrumbs>

                    <Paper className={classes.rootPaper}>
                        <FilterScreen
                            newSignature={newSignature}
                            FilterContracts={selectedFilterNames}
                            setSelectedContracts={setSelectedFilterNames}
                            FilterCategories={selectedFilterCategory}
                            setSelectedCategory={setSelectedFilterCategory}
                        />

                        <TableScreen
                            dtsize={{ x: 'min-content', y: (height - 430) }}
                            size={"small"}
                            editSystem={editSystem}
                            showConfirmDelete={showConfirmDelete}
                            employeeId={selectedFilterNames}
                            categoryId={selectedFilterCategory}
                        ></TableScreen>
                    </Paper>
                </div>
            </div>
        </div >
    )
}